var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 166,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.685 86.9487C111.93 84.8118 108.814 85.2708 105.757 86.3929C103.959 87.0525 101.066 89.3302 99.5096 89.5008C97.4681 89.7241 93.7562 88.5844 91.1877 88.6724C85.6094 88.8623 82.5138 90.6668 81.9325 96.4955C81.7784 98.0345 82.1496 99.7652 81.8432 101.267C81.5368 102.769 79.8595 104.748 79.3062 106.199C77.909 109.87 78.914 112.33 81.5543 115C58.3621 114.372 43.5146 88.5475 54.9286 67.8639C56.2716 65.4314 56.7828 64.4254 59.7698 64.1281C65.4322 63.5636 66.4862 68.395 70.6358 70.7975C74.1551 72.836 78.7792 73.4111 82.2739 71.0262C85.6706 68.7081 84.3908 66.0505 85.8335 64.1281C86.5076 63.2311 88.768 62.6754 89.7625 61.7168C92.275 59.2949 92.0281 55.2022 90.4838 52.3494C90.4786 51.6001 95.0922 53.3818 95.5807 53.5876C108.35 58.9555 116.77 73.04 114.683 86.947L114.685 86.9487Z",
    fill: "#94B5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.381 90.0337C110.468 89.9704 112.899 90.8638 113.405 91.8171C113.965 92.8742 111.055 98.6572 110.292 99.927C107.621 104.366 102.407 109.319 97.813 111.704C96.3703 112.453 91.9685 114.311 90.5328 114.439C89.1916 114.559 84.4362 111.588 83.5993 110.496C82.3457 108.864 85.942 104.542 86.3044 102.382C86.6669 100.222 85.8352 95.588 87.6911 94.0508C90.2509 91.9297 96.8798 94.4958 100.266 93.9646C103.405 93.4704 106.518 90.199 109.381 90.0337Z",
    fill: "#94B5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5201 53.0353C85.9526 53.526 86.9506 55.2074 87.0679 55.8054C87.7263 59.1718 83.3386 59.4444 81.7575 61.9032C79.7387 65.0409 81.9676 68.6694 75.8133 67.8357C70.1807 67.0724 67.915 59.0839 61.8237 59.6379C61.6311 58.8974 62.1319 58.915 62.4505 58.5879C65.5163 55.4361 72.7037 52.2737 77.0004 51.5122C80.2868 50.93 83.0864 50.281 85.5201 53.0353Z",
    fill: "#94B5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.faa735395030935eb37fe56abaf599b2.svg";
export { ForwardRef as ReactComponent };